import { connect } from 'react-redux'
import BasemapRadio from './BasemapRadio.js';
import { changeBasemap } from '../../actionCreators';

const mapStateToProps = (state, ownProps) => ({
	selected: state.basemap === ownProps.value
});

const mapDispatchToProps = (dispatch, ownProps) => ({
	onClick: () => dispatch(changeBasemap(ownProps.value))
});

export default connect(mapStateToProps, mapDispatchToProps)(BasemapRadio);


// WEBPACK FOOTER //
// ./src/components/Filter/BasemapRadioContainer.js